import { AWS_ACL, MediaS3UploadOptions, MediaSignature } from '../../types/Media';
import Api, { HttpStatusCode } from '../api/api';

const getSignature = async (acl: string, type: string, filename: string) => {
  const params = { type, acl, filename };

  const [response, bodyOrError] = await Api.get('media/signature', params);

  const { status, statusText } = response as Response;
  if (![HttpStatusCode.CREATED, HttpStatusCode.OK].includes(status)) {
    throw new Error(statusText);
  }
  return bodyOrError;
};

export const s3Upload = async (
  options: MediaS3UploadOptions,
): Promise<{
  fileName: string;
  url: string;
}> => {
  const FILENAME_PLACEHOLDER = '${filename}'; // eslint-disable-line no-template-curly-in-string
  const { resource, type, acl, onProgress, totalUploadSize = 0 } = options;
  const { url: bucketUrl, fields } = (await getSignature(acl, type, FILENAME_PLACEHOLDER)) as MediaSignature;
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    const fd = new FormData();

    const key = fields.key.replace(FILENAME_PLACEHOLDER, options.filename);

    fd.append('Content-Type', fields['Content-Type']);
    fd.append('Policy', fields.Policy);
    fd.append('X-Amz-Algorithm', fields['X-Amz-Algorithm']);
    fd.append('X-Amz-Credential', fields['X-Amz-Credential']);
    fd.append('X-Amz-Date', fields['X-Amz-Date']);
    fd.append('X-Amz-Signature', fields['X-Amz-Signature']);
    fd.append('acl', fields.acl || AWS_ACL.PUBLIC_READ_WRITE);
    fd.append('key', key);
    fd.append('success_action_status', '201');
    fd.append('file', resource);
    fd.append('Access-Control-Allow-Origin', '*');

    xhr.open('POST', bucketUrl, true);

    // Create strings
    xhr.onerror = () => reject(new Error('An error occurred during the transaction'));

    xhr.upload.onprogress = (e) => onProgress?.({ loaded: e.loaded, total: totalUploadSize });

    xhr.onreadystatechange = () => {
      if (xhr.readyState !== xhr.DONE) return;
      if (xhr.status !== HttpStatusCode.CREATED) {
        const parser = new DOMParser();
        const xmlDoc = parser.parseFromString(xhr.responseText, 'text/xml');
        return reject(xmlDoc.getElementsByTagName('Error')[0].childNodes[1].childNodes[0].nodeValue);
      }

      const delimiter = bucketUrl.endsWith('/') ? '' : '/'; // support for VirtualHosted Bucket and Path Sstyle
      const uploadedURL = [bucketUrl, key].filter(Boolean).join(delimiter);

      resolve({
        fileName: key,
        url: uploadedURL,
      });
    };

    xhr.send(fd);
  });
};
